import React, {Component} from 'react';
import {autobind} from 'core-decorators';
import PropTypes from 'prop-types';
import styles from './styles.css';

@autobind
export default class FilteredElementsCount extends Component {
    static propTypes = {
        count: PropTypes.number.isRequired,
        elementName: PropTypes.oneOf(['organización', 'pedido']).isRequired,
    };

    getSelectedElementName() {
        if (this.props.elementName === 'organización') {
            if (this.props.count === 1) return <span><strong>organización</strong> seleccionada</span>;
            return <span><strong>organizaciones</strong> seleccionadas</span>;
        }

        if (this.props.count === 1) return <span><strong>pedido</strong> seleccionado</span>;
        return <span><strong>pedidos</strong> seleccionados</span>;
    }

    render() {
        return (
            <div className={styles.root}>
                <strong>{this.props.count}</strong> {this.getSelectedElementName()} según tus filtros
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/filtered-elements-count/index.js